module.exports = __webpack_public_path__ + "d308073b/img/mini-logo.18817ee5.svg";